import React from 'react';
import styled, { keyframes } from 'styled-components';
import Spinner from '@prisjakt/ui-spinner';

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const FadeIn = styled.div`
  animation: ${fadeIn} 0.5s ease-out 1.5s 1 normal forwards;
  opacity: 0;
`;

const Loader = props => (
  <FadeIn>
    <Spinner {...props} />
  </FadeIn>
);

export default Loader;
